import { Box, Typography, InputAdornment, Alert, Paper } from '@mui/material';
import { useGetOrganizations, useUpdateOrganizations } from 'apis/agency/organizations/hook';
import { OrganizationsResponse } from 'apis/agency/organizations/types';
import DomainLockIcon from 'assets/icons/DomainLockIcon';
import PreviewDomainIcon from 'assets/icons/PreviewDomainIcon';
import Button from 'components/Common/Button';
import Input from 'components/Common/Input';
import { useForm } from 'react-hook-form';

export default function Domain() {
  const { data: organizations } = useGetOrganizations();
  const { mutateAsync: updateOrganizations } = useUpdateOrganizations();
  const { control, handleSubmit } = useForm<OrganizationsResponse>({
    values: organizations
  });

  const onSubmit = (data: OrganizationsResponse) => {
    updateOrganizations(data);
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <Paper
        elevation={0}
        sx={{
          p: 2,
          backgroundColor: '#fff',
          borderRadius: 2
        }}
      >
        <Box display='flex' flexDirection='column' gap={4}>
          <Box>
            <Typography variant='h6' fontWeight={600}>
              Custom Domain
            </Typography>
            <Typography variant='body2' color='text.secondary' mt={0.5}>
              Customize the domain where your customers access your AI agents.
            </Typography>
          </Box>
          <Box display='flex' alignItems='center' gap={2} maxWidth='460px'>
            <Input
              name='domain'
              control={control}
              disabled
              fullWidth
              size='small'
              InputProps={{
                startAdornment: (
                  <InputAdornment position='start'>
                    <DomainLockIcon />
                  </InputAdornment>
                )
              }}
            />
            <a href='mailto:vishal@kickcall.ai' style={{ textDecoration: 'none' }}>
              <Button variant='outlined' size='small' sx={{ minWidth: 150 }}>
                Request Change
              </Button>
            </a>
          </Box>
          <Typography variant='body2' color='text.secondary'>
            Domain changes require administrator approval. Please use the Request Change button to submit your request.
          </Typography>

          <Alert
            severity='warning'
            icon={false}
            sx={{
              backgroundColor: '#FFF7E6',
              border: '1px solid #FFE58F',
              px: 3
            }}
          >
            <Typography fontWeight={600} mb={0.5}>
              ⚠️ Domain Setup Information
            </Typography>
            <Typography variant='body2'>
              Please contact our support team to set up a custom domain for your business. Once approved, you'll need to
              configure DNS settings with your domain provider.
            </Typography>
          </Alert>
          <Box
            sx={{
              border: '1px solid #E0E0E0',
              borderRadius: 1,
              px: 2,
              py: 1
            }}
          >
            <Typography fontWeight={600} mb={1}>
              Preview URL
            </Typography>
            <Box
              sx={{
                border: '1px solid #E0E0E0',
                borderRadius: 1,
                bgcolor: 'rgb(228, 227, 227)',
                px: 2,
                py: 1
              }}
            >
              <Input
                name='domain'
                control={control}
                variant='standard'
                InputProps={{
                  startAdornment: (
                    <InputAdornment position='start'>
                      <PreviewDomainIcon />
                    </InputAdornment>
                  ),
                  disableUnderline: true,
                  readOnly: true
                }}
              />
            </Box>
            <Typography variant='caption' color='text.secondary' mt={0.5}>
              This is how your domain will appear to customers.
            </Typography>
          </Box>
        </Box>
      </Paper>
      {/* <Box mt={3} display='flex' justifyContent='flex-end' gap={2}>
        <Button variant='contained' type='submit'>
          Save Branding
        </Button>
      </Box> */}
    </form>
  );
}
